import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, watch } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  value: {
    type: [String, Number, Array]
  },
  maxTagCount: {
    type: [Number, String]
  },
  disabled: {
    type: Boolean,
    default: false
  },
  filterVal: {
    type: Array,
    default: () => [null, '', 0]
  }
},
  emits: ['update:value', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props
const data = ref()
watch(
  () => props.value,
  (v) => {
    if (!v) {
      if (props.filterVal.includes(v)) {
        data.value = undefined
        return
      }
    }
    data.value = v
  },
  { immediate: true }
)
const pageMaxTagCount = computed(() => {
  if (props.maxTagCount) {
    return props.maxTagCount
  }
  if (props.disabled) {
    return 100
  }
  return 'responsive'
})
const emit = __emit
const change = (value: any) => {
  emit('update:value', value)
  emit('change', value)
}

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, _mergeProps({ "allow-clear": "" }, _ctx.$attrs, {
    value: data.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data).value = $event)),
    style: {"width":"100%"},
    placeholder: "请选择",
    disabled: __props.disabled,
    onChange: change,
    "max-tag-count": pageMaxTagCount.value
  }), null, 16, ["value", "disabled", "max-tag-count"]))
}
}

})